import { render, staticRenderFns } from "./productDesciption.vue?vue&type=template&id=c1bace1e&"
import script from "./productDesciption.vue?vue&type=script&lang=ts&"
export * from "./productDesciption.vue?vue&type=script&lang=ts&"
import style0 from "./productDesciption.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports